import type { Dispatch, SetStateAction } from 'react';
import type { ColorField } from '@prismicio/client';

export interface ILocation {
  label: string;
  lat: number;
  lng: number;
  title: string;
  pin?: string;
  photo?: string;
  google_map_url?: string;
  url_slug?: string;
}

export interface IMarkerStyle {
  titleColor: ColorField;
  /** Default fill for the vector pin when no custom image is used */
  defaultMarkerColor: ColorField;
}

/** Kept as `rigth` to match existing SCSS module class `centered-rigth` and call sites */
export type CenteredMode = 'center' | 'left' | 'SE' | 'rigth';

export type MapStyleTokens = 'brand' | 'dark' | 'gray' | 'inverted' | 'default';

export const MAP_STYLE_VALUES: MapStyleTokens[] = [
  'brand',
  'dark',
  'gray',
  'default',
  'inverted',
];

export type MapPalette = {
  background: string;
  surfaceSubtle: string;
  surfaceMuted: string;
  water: string;
  textPrimary: string;
  textSecondary: string;
  road: string;
  roadHighway: string;
  transit: string;
  transitStation: string;
  park: string;
  parkText: string;
  poi: string;
  poiText: string;
  landParcelText: string;
  markerTitle: string;
  tooltipText: string;
  tooltipBackground: string;
  tooltipBorder: string;
  tooltipBorderRadius: string;
};

export interface CreateMarkerOptions {
  lat: number;
  lng: number;
  label: string;
  map: google.maps.Map;
  bounds?: google.maps.LatLngBounds;
  pin?: string;
  locationImage?: string;
  googleMapUrl?: string;
  narrowTooltip?: boolean;
}

export interface IMapsProps {
  actionClickMarker?: Dispatch<SetStateAction<google.maps.Marker>>;
  centered?: CenteredMode;
  className?: string;
  context?: string;
  hideInterestingPoints?: boolean;
  locations: ILocation[];
  openInfo?: boolean;
  mapStyleTokens?: MapStyleTokens;
  pinColor?: ColorField;
  defaultMarker?: string;
  markerStyle?: IMarkerStyle;
  zoom?: number;
  /** When true, InfoWindow content uses a narrower max-width (e.g. dispensary location page). */
  narrowMapTooltip?: boolean;
  showTitle?: boolean;
}
